import { FC } from "react";
import { useTheme } from "@mui/system";
import ReactApexChart from "react-apexcharts";

interface Prop {
  colors: any[];
  chartData: any[];
  categories: any[];
  height: number | string;
}
const HeatmapChart: FC<Prop> = (props) => {
  const theme = useTheme();
  const { colors, height, chartData, categories } = props;
  const series = chartData;
  const options: object = {
    chart: {
      type: "heatmap",
      background: "transparent",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      heatmap: {
        radius: "30px",
        enableShades: false,
      },
    },
    colors: colors,
    xaxis: {
      categories: categories,
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      crosshairs: {
        show: false,
      },
    },
    theme: {
      mode: theme.palette.mode,
    },
    grid: {
      yaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        top: 0,
        right: 20,
        bottom: 0,
        left: 15,
      },
    },
    stroke: {
      show: true,
      colors: ["none"],
      width: 15,
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="heatmap"
      height={height}
    />
  );
};

export default HeatmapChart;
